import GLightbox from 'glightbox';

export default class Gallery {
  constructor(element) {
    this.element = element;
    this.lightbox = null;
    this.pendingVideoIndex = null;
  }

  isYoutubeConsented() {
    if (typeof tarteaucitron === 'undefined') return true;
    if (!tarteaucitron.job?.includes('youtube')) return true;
    return tarteaucitron.state?.youtube === true;
  }

  mount() {
    const videoLinks = [...this.element.querySelectorAll('.glightbox[href*="youtube"]')];
    const allItems = [...this.element.querySelectorAll('.glightbox')];

    // Les listeners de consentement sont enregistrés AVANT GLightbox pour s'exécuter
    // en premier et bloquer GLightbox via stopImmediatePropagation si besoin.
    videoLinks.forEach(($link) => {
      $link.addEventListener('click', (e) => {
        if (this.isYoutubeConsented()) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        this.pendingVideoIndex = allItems.indexOf($link);

        if (typeof tarteaucitron !== 'undefined') {
          tarteaucitron.userInterface.openPanel();
        }

        document.addEventListener('youtube_consentModeOk', () => {
          if (this.pendingVideoIndex !== null) {
            this.lightbox.openAt(this.pendingVideoIndex);
            this.pendingVideoIndex = null;
          }
        }, { once: true });
      });
    });

    this.lightbox = GLightbox({
      selector: '.glightbox',
      autoplayVideos: false,
    });

    this.lightbox.on('open', () => {
      this._triggerElement = document.activeElement;

      const closeButton = document.querySelector('.gclose');
      if (closeButton) {
        closeButton.setAttribute('aria-label', 'Fermer la fenêtre');
        closeButton.focus();
      }

      document.querySelector('.gnext')?.setAttribute('aria-label', 'Suivante');
      document.querySelector('.gprev')?.setAttribute('aria-label', 'Précédente');
    });

    this.lightbox.on('close', () => {
      this._triggerElement?.focus();
    });
  }
}
